var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.765,
    cy: 24.765,
    r: 24.765,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3486 15.6582L21.3735 15.3305C22.3355 15.0238 23.3614 15.5201 23.7738 16.4897L24.592 18.4214C24.9482 19.2625 24.7511 20.2521 24.1024 20.8674L22.2984 22.58C22.4089 23.6049 22.7537 24.6136 23.3309 25.6061C23.8793 26.5664 24.6149 27.4069 25.494 28.0778L27.6609 27.3539C28.483 27.0806 29.3773 27.3959 29.8803 28.136L31.0547 29.86C31.6405 30.721 31.5357 31.9079 30.809 32.6375L30.0298 33.4195C29.2545 34.1977 28.1467 34.4806 27.1228 34.1605C24.7044 33.4061 22.4812 31.1668 20.4524 27.4425C18.4207 23.7125 17.7035 20.5464 18.3017 17.948C18.5531 16.8545 19.3313 15.983 20.3486 15.6582Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2cfdd4fe3390882ca6848e6c38b72b6a.svg";
export { ForwardRef as ReactComponent };